import axios from "axios";
import ItemDataParser from "./ItemDataParser";

class ItemService {
  getItemData(itemid) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/item.json')
      .then(res => ItemDataParser.mapContentItemToResult(res.data))
      .catch(error => { });
  }

  getItemDataByPath(path) {

    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/item.json')
      .then(res => ItemDataParser.mapContentItemToResult(res.data))
      .catch(error => { });
  }

  getItemVersionHistory(itemid) {
    return axios
      .get('/sitecore/shell/client/Applications/altola/insights/data/item-versions.json')
      .then(result => ItemDataParser.createChangeHistory(result.data))
      .catch(error => { });
  }
}

export default new ItemService();


// WEBPACK FOOTER //
// ./src/data/ItemService.dev.js